export const PORT = "https://api.sortyfy.com";

export const API_URL = "https://api.sortyfy.com/api/vendor";
export const API_URL2 = "https://api.sortyfy.com/api";
export const MAX_WORDS = 500;
export const MIN_WORDS = 50;
export const upperCaseByWord = (str) => {
  if (str) {
    const words = str.split(" ");

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0]?.toUpperCase() + words[i]?.substr(1) + " ";
    }
    return words;
  }
  return str;
};

export const daysData = [
  {
    day: "Monday",
    fromTime: "10:00",
    toTime: "23:00",
    fullDay: false,
  },
  {
    day: "Tuesday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Wednesday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Thursday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Friday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Saturday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Sunday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
];

export const trimStringWithEllipsis = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str;
  }
  return str.slice(0, maxLength) + "...";
};
